$(document).ready(function () {
    /**
     * Handles click event on the "load more" button
     * @param {Object} $this - the clicked element
     * @param {Object} $parent - the parent element of the clicked element
     * @param {Number} pageSize - the page size of the parent element
     * @param {Number} contentSize - the content size of the parent element
     */
    $(".js-folder-tabs .js-load-content").on("click", function () {
        const $this = $(this);
        const $gridWrapper = $this.parents(".js-tab-container").find(".js-tab-grid");
        const pageSize = parseInt($this.data("pageSize"), 10);
        const contentSize = parseInt($this.data("contentSize"), 10);
        const dataUrl = $this.data("ajaxUrl");
        const folderId = $this.data("tabFolderId");
        let loadingIndex = $this.data("loadingIndex");

        // increment the loading index by the page size
        // this will be used to get the next items in the list
        loadingIndex = loadingIndex + pageSize;

        // create the url to load the next items in the list
        const url = dataUrl + "?startItem=" + loadingIndex + "&fdid=" + folderId + "&sizes=" + pageSize;

        // store the loading index in the button data
        $this.data("loadingIndex", loadingIndex);

        $.spinner().start();

        // make the ajax call to get the next items in the list
        $.ajax({
            url: url,
            method: "GET",
            success: function (response) {
                // remove the button if there is no more content to load
                if ((contentSize - pageSize) <= loadingIndex) {
                    $this.remove();
                }

                // append the new content to the grid wrapper
                $gridWrapper.append(response);

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $(".js-folder-tabs [data-first-load-content]").one("shown.bs.tab", function () {
        const $this = $(this);
        // get the first load content url
        // this will be used to load the content of the tab on the first load
        // the content will be loaded only once
        // after that, the content will be loaded when the user clicks on the "load more" button
        const firstLoadContent = $this.attr("data-first-load-content");

        if (firstLoadContent) {
            // get the grid wrapper
            const $gridWrapper = $("#tab-" + $this.attr("id")).find(".js-tab-grid");

            // remove the attribute so we don't load the content again
            $this.removeAttr("data-first-load-content");

            $.spinner().start();

            // load the content
            $.ajax({
                url: firstLoadContent,
                method: "GET",
                success: function (response) {
                    // append the new content to the grid wrapper
                    $gridWrapper.append(response);

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    // handle the popup open event
    $(document).on("click", ".js-grid-modal-cta", evt => {
        const $this = $(evt.currentTarget);

        // get Ajax URL and content asset ID
        const $folderWrapper = $this.closest(".js-folder-tabs");
        const ajaxUrl = $folderWrapper.data("getModalContentAjaxUrl");
        const assetId = $this.data("assetId");

        // return if ajaxUrl or assetId is missing
        if (!ajaxUrl || !assetId) {
            return;
        }

        // build the url
        const url = ajaxUrl + "?cid=" + assetId;

        $.spinner().start();
        $.get(url, response => {
            if (!response) {
                $this.remove();
                return;
            }

            // get the modal and modal content wrapper
            const $modal = $folderWrapper.find($this.data("target"));
            const $innerContainer = $(".js-grid-modal-inner", $modal);

            // inject the content in DOM and show the modal
            $innerContainer.html(response);
            $modal.modal("show");

            // remove the "js-" class from the button to prevent another request
            $this.removeClass("js-grid-modal-cta").attr("data-toggle", "modal");

            $.spinner().stop();
        });
    });

    // Scroll into view if the selected item is partially out of the container
    $(".folder-tabs__item").on("click", function () {
        const $item = $(this);
        const $container = $item.closest(".folder-tabs__list");
        const itemOffset = $item.position().left;
        const containerScroll = $container.scrollLeft();
        const containerWidth = $container.width();
        const scrollTo = containerScroll + itemOffset - containerWidth / 2 + $item.width() / 2;

        $container.animate({
            scrollLeft: scrollTo
        }, 500);
    });
});
